import React, { useEffect, useState, useRef } from 'react'
import StoreFilter from './StoreFilter'
import AllProducts from './components/AllProducts'
import { setItemsFilter, setStoreProfileFilterPage } from 'reducers/contentReducer'
import { useDispatch, useSelector } from 'react-redux'
import FilterSideSelectedMobile from './components/FilterSideSelectedMobile'
import StoreCategories from './components/StoreCategories'
import StoreBrands from './components/StoreBrands'
import { Select } from "antd"
import { IoSearch } from "react-icons/io5"

const tabs = [
    'All Items',
    'New Items',
    'Hot Deals',
]

const SORTBY = [
    'Most Popular',
    // 'Newest',
    'Low to High',
    'High to Low',
]

export default function StoreMain({
    isMobile,
    business,
    // location
}) {

    const [width, setWidth] = useState(1200) // State to store the width
    const productRef = useRef(null)

    const dispatch = useDispatch()
    const storeProfileFilter = useSelector(state => state.content.itemsFilter)
    const [products, setProducts] = React.useState(null)
    const [tab, setTab] = React.useState('All Items')
    const [sortBy, setSortBy] = React.useState('Most Popular')
    const [search, setSearch] = React.useState('')
    const [isShowSearch, setIsShowSearch] = React.useState(false)

    useEffect(() => {
        // Function to update the width
        const updateWidth = () => {
            if (productRef.current) {
                console.log(productRef.current.offsetWidth)
                setWidth(productRef.current.offsetWidth) // Get the width using offsetWidth
            }
        }
        // Update the width when the component mounts
        updateWidth()
        // Optionally, update the width when the window is resized
        window.addEventListener('resize', updateWidth)
        // Cleanup the event listener on unmount
        return () => window.removeEventListener('resize', updateWidth)
    }, [productRef])

    console.log('storeProfileFilter', storeProfileFilter)
    let isSearch = false
    if (storeProfileFilter.title ||
        storeProfileFilter.brands.length > 0 ||
        storeProfileFilter.categories.length > 0 ||
        storeProfileFilter.condition.length > 0 ||
        (storeProfileFilter.priceMin !== -1 || storeProfileFilter.priceMax !== -1) ||
        storeProfileFilter.deliveryTypes.length > 0 ||
        storeProfileFilter.isOnSale
    ) {
        isSearch = true
    }

    const setFilterBrandCheckOne = (value) => {
        console.log('setFilterBrandCheckOne value', value)
        let brands = storeProfileFilter.brands
        if (value.checked) {
            if (!brands.includes(value._id)) {
                brands = [...brands, value._id]
            }
        } else {
            brands = brands.filter(item => item !== value._id)
        }
        dispatch(setItemsFilter({
            ...storeProfileFilter,
            brands: brands
        }))
        // jump to id = store-all-products soomth the y-200 based on the element
        const element = document.getElementById('store-all-products')
        if (element) {
            // element.scrollIntoView({ behavior: 'smooth', block: 'start' })
            window.scrollTo({
                top: element.offsetTop - 500,
                behavior: 'smooth',
            })
        }
    }
    const setFilterCategoryCheckOne = (value) => {
        console.log('setFilterCategoryCheckOne value', value)
        const isExist = storeProfileFilter.categories.find(item => item === value._id)
        dispatch(setItemsFilter({
            ...storeProfileFilter,
            categories: isExist
                ? storeProfileFilter.categories.filter(item => item !== value._id)
                : [...storeProfileFilter.categories, value._id]
        }))
    }

    return (
        <>
            <div className='w-full flex h-full bg-white smsize:flex-col'>
                {!isMobile &&
                    <StoreFilter business={business} isMobile={isMobile} setFilterBrandCheckOne={setFilterBrandCheckOne} />
                }
                <div className='flex flex-col w-full'>
                    {!isMobile &&
                        <FilterSideSelectedMobile
                            brands={business?.brands}
                            categories={business?.categories}
                            storeCategories={business?.storeCategories}
                            storeProfileFilter={storeProfileFilter}
                            isMobile={isMobile}
                            dispatch={dispatch}
                        />
                    }
                    <div ref={productRef} id='store-main-product' className='flex-2 w-full py-[30px] px-[30px] flex flex-col items-start justify-start gap-3 smsize:p-5'>
                        <StoreCategories
                            business={business}
                            isMobile={isMobile}
                            width={width}
                            setFilterCategoryCheckOne={setFilterCategoryCheckOne}
                            storeProfileFilter={storeProfileFilter}
                        />
                        <StoreBrands
                            business={business}
                            isMobile={isMobile}
                            width={width}
                            setFilterBrandCheckOne={setFilterBrandCheckOne}
                            storeProfileFilter={storeProfileFilter}
                        />
                        <div className='w-full flex items-center justify-between pt-2 text-[14px]'>
                            {/* {tabs.map((t, i) => (
                                <div
                                    key={i}
                                    onClick={() => {
                                        console.log('tab', t)
                                        setTab(t)
                                        dispatch(setStoreProfileFilterPage(1))
                                    }}
                                    className={`cursor-pointer leading-9 ${tab === t ? 'border-b-[3px] border-[#E4B456]' : ''}`}>
                                    {t}
                                </div>
                            ))} */}
                            <div className='flex items-center gap-2 '>
                                {/* <span>Filter By:</span> */}
                                <Select
                                    className='w-[150px] smsize:w-full text-left'
                                    value={tab}
                                    onChange={(value) => {
                                        console.log('tab', value)
                                        setTab(value)
                                        dispatch(setStoreProfileFilterPage(1))
                                    }}
                                    options={tabs.map(t => ({ label: t, value: t }))}
                                />
                                <div className='flex items-center gap-2'>
                                    <IoSearch size={16} className='cursor-pointer' onClick={() => setIsShowSearch(!isShowSearch)} />
                                    {isShowSearch &&
                                        <input
                                            type="text"
                                            name="search"
                                            id="search"
                                            placeholder='Search...'
                                            autoFocus
                                            onFocus={() => setIsShowSearch(true)}
                                            value={search}
                                            onChange={(e) => {
                                                // setSearch(e.target.value)
                                                dispatch(setStoreProfileFilterPage(1))
                                            }}
                                            className='w-[200px] smsize:w-[120px] border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500'
                                        />
                                    }
                                </div>
                            </div>
                            <div className='flex items-center gap-1'>
                                {/* <span>Sort By:</span> */}
                                <Select
                                    className='w-[200px] smsize:w-full text-left'
                                    value={sortBy}
                                    onChange={(value) => {
                                        console.log('sortBy', value)
                                        // setSortBy(value)
                                        dispatch(setStoreProfileFilterPage(1))
                                    }}
                                    options={SORTBY.map(t => ({ label: t, value: t }))}
                                />
                            </div>
                        </div>
                        <div className='w-full flex flex-col items-start'>
                            <AllProducts
                                business={business}
                                isMobile={isMobile}
                                isSearch={isSearch}
                                products={products}
                                setProducts={setProducts}
                                tab={tab}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
